import React from 'react';
import { Outlet, useNavigation } from 'react-router-dom';
import HeaderDropDowns from '@/root/portals/HeaderDropdowns';
import MobileNav from '@/root/portals/MobileNav';
import MiniCart from '@/root/portals/MiniCart';
import NavSearch from '@/root/portals/NavSearch';
import Debug from '@/root/portals/Debug';
import Watermark from '@/root/portals/Watermark';
import SitewideBanner from '@/root/portals/SitewideBanner';

export default () => {
  const navigation = useNavigation();

  // console.log('Portals', { navigation });

  return <>
    <SitewideBanner/>
    <HeaderDropDowns/>
    <NavSearch/>
    <MobileNav/>
    <MiniCart/>
    <Watermark/>
    <Debug/>
  </>
};